import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 8px;
  @media (max-width: 800px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const Subtitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral500};
  margin-bottom: 40px;
`;

export const Image = styled.img`
  width: 160px;
  margin-bottom: 40px;
`;

export const SmallTxt = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => props.theme.colors.neutral500};
`;

export const Info = styled.div`
  width: 100%;
  display: flex;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 8px;

  div {
    color: ${(props) => props.theme.colors.neutral500};
    font-weight: normal;
    width: 120px !important;
    flex: none;
  }
`;

export const InfoRight = styled(Info)`
  span {
    width: 200px;
    text-align: right;
  }
  div {
    width: calc(100% - 200px) !important;
    text-align: right;
  }
`;

export const BankAccount = styled.div<{ selected: boolean; disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  background: ${(props) =>
    props.selected
      ? props.theme.colors.secondary100
      : props.theme.colors.neutral100};
  padding: 1px;
  border-radius: 8px;
  margin-bottom: 12px;
  > div {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    color: #b5a8a8;
    padding: 0 20px;
    border-radius: 8px;
    background: ${(props) =>
      props.selected
        ? props.theme.colors.neutral50
        : props.theme.colors.neutral100};
    span {
      ${(props) => (props.selected ? 'color: #FEFEFE' : '')};
    }
    img {
      margin-right: 20px;
    }
    > div {
      width: 100%;
    }
  }
`;
